module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Media-library1-881d251f2b12869db7554b0f5a47812f.svg";